export default {
    data() {
        return {
            selectedCountryName: null,
            provinces: [],
            loadingProvinces: false,
            loadingCountries: false,
        };
    },
    computed: {
        countries() {
            return this.$root.v2.countries;
        },
        countriesUrl() {
            return `/api/v1/countries`;
        },
    },
    methods: {
        loadProvinces() {
            this.loadingProvinces = true;
            let country = this.countries.find(country => this.selectectedCountryName === country.name);

            if(!country){
                return Promise.resolve();
            }

            return this.$http.get(`/api/v1/countries/${country.id}/provinces`)
                .then(res => this.provinces = res.data)
                .catch(error => this.handleHttpError(error))
                .then(() => this.loadingProvinces = false)
                ;
        },
        loadCountries() {
            if (this.$root.v2.countries.length > 0) {
                return Promise.resolve();
            }

            this.loadingCountries = true;

            return this.$http.get(this.countriesUrl)
                .then(res => {
                    this.$root.v2.countries = res.data;
                })
                .catch(error => console.log(error))
                .then(() => {
                    this.loadingCountries = false
                    return this.loadProvinces();
                });
        },
        countryUpdated(name) {
            if (name && name !== this.selectectedCountryName) {
                this.selectectedCountryName = name;
                this.loadProvinces();
            }
        }
    },
}

